import React, {useEffect, useState} from 'react'
import _, { set } from 'lodash';
import {apiServices} from '../../services/apiServices'
import moment from 'moment';

import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import CardHeader from '@material-ui/core/CardHeader';

import Avatar from '@material-ui/core/Avatar';
import DescriptionIcon from '@material-ui/icons/Description';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';

import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import swal from 'sweetalert'
import { useHistory } from "react-router";

import '../../assets/css/customstyles.css'

import { useLocation } from "react-router-dom";
import OfflineDb from '../../db'
import {useGlobalSpinnerActionsContext} from '../../context/GlobalSpinnerContext'
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import { use } from 'react';
const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
    },
  }));

function SeeIndividualRecord(){
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const [trackedEntityInstance] = useState(location.state.trackedEntityInstance);
    const [sessionUserBoValue, setSessionUserBoValue] = useState(null);
    const [sessionMetaData, setSessionMetaData] = useState(null);
    const [eventsData, setEventsData] = useState(null);
    const [orgUnitName, setorgUnitName] = useState(null);
    const [attribute, setattribute] = useState([]);
    const setGlobalSpinner = useGlobalSpinnerActionsContext()
    const [OUJSON, setOUJSON] = useState(null)
    const [facilityList, setfacilityList] = useState(null)
    const [rolename, setrolename] = useState(null)

    async function getUserMeta() {
        
        let OU = await OfflineDb.getDataFromPouchDB('OUStructureJSON')
        setOUJSON(OU.data.organisationUnits)

        let metadata = await OfflineDb.getDataFromPouchDB('metaData');
        setSessionMetaData(metadata.data)

        let userdata = await OfflineDb.getDataFromPouchDB('loginDetails');
        setSessionUserBoValue(userdata.data)
    }
    
    useEffect(() => {
        getUserMeta();
        setGlobalSpinner(false)
    }, [])

    useEffect(()=>{
        if(sessionUserBoValue != null){
            getFacilityList();
            const userRole = sessionUserBoValue ? sessionUserBoValue.userRoles : null;

            const roleName = userRole
                ? userRole.find((role) => role.name === "Data  Administrator")?.name
                : null;
            setrolename(roleName)
        }
    },[sessionUserBoValue])

    useEffect(()=>{
        if(facilityList != null){
            getDetails();
        }
    },[facilityList])

    const getTranslatedLabels = (attribute) => {
        if (localStorage.getItem("locale") == "en") {
            return attribute.displayName;
        } else if (attribute.translations && attribute.translations.length > 0) {
            //debugger;
            let label = attribute.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
            if (label.length > 0) {
                return label[0].value;
            } else {
                return attribute.displayName;
            }
        }
        return attribute.displayName;
      };

    function getDetails(){
        setGlobalSpinner(true)
        const programId = sessionUserBoValue.programs[0]
        const getURL = 'trackedEntityInstances/' + trackedEntityInstance + '.json?program='+ programId +'&fields=*?'
        apiServices.getAPI(getURL)
        .then(res => {
            setGlobalSpinner(false)
            console.log("res>>",res)
            let allEvents = res.data.enrollments[0].events;
            let dataattribute = res.data.attributes;
            setattribute(dataattribute)
            setEventsData(allEvents)
            setorgUnitName(res.data.enrollments[0].orgUnitName)
            if(allEvents.length == 0 ||  allEvents.length < 1) {
                swal({
                    title: t("Success"),
                    text: t("No records found"),
                    icon: "success",
                    button: t("Close"),
                  })
                  .then(res => {
                    if(res) {
                        
                        history.goBack()
                    //   history.push('layout/cases')
                    }
                })
            }
        })
        .catch(error => {
            setGlobalSpinner(false)
            swal({
                title: t("Error"),
                text: error,
                icon: "error",
                button: t("Close"),
              });
        })
    }

    function updateRegistration() {
        setGlobalSpinner(true);
        const activeCaseDetails = {
            trackedEntityInstance: trackedEntityInstance,
            enrollmentId: "",
            stageuid: "",
        };
        history.push("/layout/registration")
        OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
    }
function UpdateRecordClick(e, eventObj, filterStageEvent ) {
    console.log("UpdateRecordClick>>", e, eventObj, filterStageEvent);
    const PropsArray = {};

  // Step 1: Add dataValues
  eventObj.dataValues.forEach((item) => {
    const key = item.dataElement;
    const value = item.value;
    PropsArray[key] = value;
  });

  // Step 2: Add static keys program
  PropsArray["stageuid"] = filterStageEvent[0].id;
  PropsArray["stageinstanceuid"] = eventObj.programStage;
  PropsArray["instanceuid"] = eventObj.trackedEntityInstance;
  PropsArray["event"] = eventObj.event;

//   return PropsArray;

//   console.log("UpdateRecordClick>>", e, PropsArray);

setGlobalSpinner(true);

    const formDataMassaged = {};
    const activeCaseDetails = {
      trackedEntityInstance: PropsArray.instanceuid,
      enrollmentId: "",
      stageuid:  PropsArray.stageuid,
    };

    const linkContact = {
      enabled: false,
      linkTrackedEntityInstance: PropsArray.instanceuid,
    };

    console.log("activeCaseDetails>>", activeCaseDetails);
    
    OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
    setGlobalSpinner(false);
    history.push({pathname : "/layout/registration",
         state: { from: '/layout/individualrecord', stageId: 'individualrecord' }} );
  }
    function getFacilityList() {
        apiServices.postAPI('save/org/list', {"uid" : "diBTNzaEMGg"})
        .then(ouResponse => {
            const fetchOUOptions = ouResponse.data.data
            const OUOptions = fetchOUOptions.map(o => {
                return {
                    ...o,
                    displayName: o.name
                }
            });
            setfacilityList(OUOptions)
        })
    }

    function createStructure (events){
        console.log("events>>", events)

        const dataElements = sessionMetaData.dataElements
        let tempDataValue = _.cloneDeep(events.dataValues)
        let reverseDV = _.cloneDeep(tempDataValue.reverse())

        let stageEvent = sessionMetaData.programs[0].programStages.find(obj => obj.id == events.programStage)
        return stageEvent.programStageDataElements.map((field,i) => {
            return tempDataValue.map((values,i) => {
                if(field.dataElement.id == values.dataElement){
                    const filterShowFlagAttr = field.dataElement.attributeValues.filter(obj => obj.attribute.displayName == "enableInIndividualRecord")
                    if(filterShowFlagAttr.length > 0) {
                        try{
                            if(field.dataElement.valueType == "DATE") { //IF VALUE OF DATAELEMENT IS DATE 
                                values.value = moment(values.value).format("YYYY-MM-DD")
                            }
                            if(field.dataElement.valueType == "ORGANISATION_UNIT") { 
                                let orgobj = sessionMetaData.programs[0].organisationUnits.find(o => o.id == values.value)
                                if(orgobj){
                                    values.value = getTranslatedLabels(orgobj)
                                }
                                if(!orgobj) {
                                    let facilityobj = facilityList.find(o => o.uid == values.value)
                                    if(facilityobj) {
                                        orgobj = getTranslatedLabels(facilityobj)
                                    }
                                }
                            }
                            if(field.dataElement.optionSet){
                                field.dataElement.optionSet.options.map(option => {
                                if(option.code == values.value){
                                    values.value = getTranslatedLabels(option)
                                }
                            })
                            }
                        }catch(e){
    
                        }
                        return (
                            <>
                             <ListItem key={i}>
                                <ListItemAvatar>
                                    <Avatar>
                                        <DescriptionIcon />
                                    </Avatar>
                                </ListItemAvatar>
                                {/* <Typography>
                                    <span className="zero servicequestiontitle">{filterFieldData[0].dataElement.displayName} : </span>&nbsp;
                                    <span className="zero servicequestionanswer">{orgobj ? orgobj.displayName:values.value}</span>
                                </Typography> */}
                                    <Typography>
                                    <span className="zero servicequestiontitle">{getTranslatedLabels(field.dataElement)} : </span>&nbsp;
                                    <span className="zero servicequestionanswer">{values.value}</span>
                                    {/* <span className="zero servicequestionanswer">{events.storedBy}</span> */}
                                </Typography>
                            </ListItem>
                            </>
                        )
                    }
                }
            })
        })
        
        // return reverseDV.map((values,i) => {
        //     return sessionMetaData.programs[0].programStages.map(stages => {
        //         let filterFieldData = stages.programStageDataElements.filter(obj => obj.dataElement.id == values.dataElement)
                
        //         if(filterFieldData.length > 0) { 
        //             const filterShowFlagAttr = filterFieldData[0].dataElement.attributeValues.filter(obj => obj.attribute.displayName == "enableInIndividualRecord")
        //             // console.log('filterShowFlagAttr>>', filterFieldData[0].dataElement.displayName, filterShowFlagAttr)
        //             if(filterShowFlagAttr.length > 0) {

        //                 try{
        //                     if(filterFieldData[0].dataElement.valueType == "DATE") { //IF VALUE OF DATAELEMENT IS DATE 
        //                         values.value = moment(values.value).format("YYYY-MM-DD")
        //                     }
        //                     if(filterFieldData[0].dataElement.valueType == "ORGANISATION_UNIT") { 
        //                         let orgobj = sessionMetaData.programs[0].organisationUnits.find(o => o.id == values.value)
        //                         if(orgobj){
        //                             values.value = getTranslatedLabels(orgobj)
        //                         }
        //                         if(!orgobj) {
        //                             let facilityobj = facilityList.find(o => o.uid == values.value)
        //                             if(facilityobj) {
        //                                 orgobj = getTranslatedLabels(facilityobj)
        //                             }
        //                         }
        //                     }
        //                     if(filterFieldData[0].dataElement.optionSet){
        //                     filterFieldData[0].dataElement.optionSet.options.map(option => {
        //                         if(option.code == values.value){
        //                             values.value = getTranslatedLabels(option)
        //                         }
        //                     })
        //                     }
        //                 }catch(e){
    
        //                 }
        //                 return (
        //                     <ListItem key={i}>
        //                         <ListItemAvatar>
        //                             <Avatar>
        //                                 <DescriptionIcon />
        //                             </Avatar>
        //                         </ListItemAvatar>
        //                         {/* <Typography>
        //                             <span className="zero servicequestiontitle">{filterFieldData[0].dataElement.displayName} : </span>&nbsp;
        //                             <span className="zero servicequestionanswer">{orgobj ? orgobj.displayName:values.value}</span>
        //                         </Typography> */}
        //                          <Typography>
        //                             <span className="zero servicequestiontitle">{getTranslatedLabels(filterFieldData[0].dataElement)} : </span>&nbsp;
        //                             <span className="zero servicequestionanswer">{values.value}</span>
        //                         </Typography>
        //                     </ListItem>
        //                 )
        //             }
        //         }
                    
                
        //     })
             
        // })
    }

    
    const findEvent = (displayName) => {
        return attribute.find(event => event.displayName === displayName);
      };
    
      const genderLabel = (value) => {
        switch (value) {
          case "1":
            return "Male";
          case "2":
            return "Female";
          case "3":
            return "Transgender woman";
          case "4":
            return "Transgender man";
          default:
            return "";
        }
      };

      const uicEvent = findEvent("UIC");
      const nickNameEvent = findEvent("Nick Name");
      const genderEvent = findEvent("Gender");
      const ageEvent = findEvent("Age");

    function getEntityData(events,i) {
        const userRole = sessionUserBoValue ? sessionUserBoValue.userRoles : null;
        const roleName = userRole
        ? userRole.find((role) => role.name === "Data  Administrator")?.name
        : null;
        // setrolename(roleName)
        console.log("sessionUserBoValue>>", sessionUserBoValue)
        const classes = makeStyles((theme) => ({
            root: {
              width: '100%',
              maxWidth: 360,
              backgroundColor: theme.palette.background.paper,
            },
          }));

        // console.log("userRole", roleName)
        

        const allStages = sessionMetaData.programs[0].programStages

        const filterStageEvent = allStages.filter(obj => obj.id == events.programStage)
        console.log("filterStageEvent>>", filterStageEvent, allStages)
        
        return (
            <Grid item xs={12} sm={6} md={4} key={i}>
                <Card className={classes.root}>
                    <CardHeader
                        className="casescardheader"
                        avatar={
                        <Avatar aria-label="recipe" className={classes.avatar}>
                            <DescriptionIcon />
                        </Avatar>
                        }
                        
                        title={moment(events.lastUpdated).format("MMMM Do YYYY, h:mm a")}
                        subheader={filterStageEvent && filterStageEvent.length > 0 ? filterStageEvent[0].displayName : ''} 
                        // action={
                        //     roleName == "Data  Administrator" ?
                        //     <IconButton aria-label="recipe" className={classes.avatar} onClick={(e) => UpdateRecordClick(e, events, filterStageEvent)}>
                        //         <EditIcon style={{ color: "white" }}/>
                        //     </IconButton>
                        //     :
                        //     <></>
                        // }                        
                    />
                    
                    <CardContent className="zero caselistholder serviceslist seviceslist-cardbody content-container">
                    <div className="content-scrollable">
                        <List className={classes.root}>
                        <ListItem key={i}>
                            <ListItemAvatar>
                            <Avatar>
                                <DescriptionIcon />
                            </Avatar>
                            </ListItemAvatar>
                            <Typography>
                            <span className="zero servicequestiontitle">Service by: </span>
                            <span className="zero servicequestionanswer">{events.storedBy}</span>
                            </Typography>
                        </ListItem>
                        {createStructure(events)}
                        </List>
                    </div>

                    </CardContent>

                    {/* <CardHeader> */}
                       
                    {/* </CardHeader> */}
                    
                </Card>
            </Grid>
        )        
    }  
    const sortedEvents = eventsData
    ? eventsData.sort(
        (a, b) => new Date(a.created) - new Date(b.created)
      )
    : []; 
    
    return (
        <section className="searchcustombg"
                style={{
                    backgroundColor: '#fff',
                    flexGrow: 1,
                    padding: 20,
                    
                }}
           >
            {/* attribute */}
            <Grid className='patientinfo'>
                <Box className='patientinfoin'>
                <div direction="row" justifyContent="space-between" alignItems="center">
                    {uicEvent ? `UIC : ${uicEvent.value}` : ""}
                </div>
                <div direction="row" justifyContent="space-between" alignItems="center">
                    {nickNameEvent ? `Nick Name : ${nickNameEvent.value}` : ""}
                </div>
                <div direction="row" justifyContent="space-between" alignItems="center">
                    {orgUnitName ? `Hotspot : ${orgUnitName}` : ""}
                </div>
                <div direction="row" justifyContent="space-between" alignItems="center">
                    {genderEvent ? `Gender : ${genderLabel(genderEvent.value)}` : ""}
                </div>
                <div direction="row" justifyContent="space-between" alignItems="center">
                    {ageEvent ? `Age : ${ageEvent.value}` : ""}
                </div>
                {/* <div> */}
               {/* {rolename == "Data  Administrator" ?
                    <IconButton className='headeredit' aria-label="recipe" onClick={(e) => updateRegistration(e, eventsData[0])}>
                        <EditIcon style={{ color: "white" }}/>
                    </IconButton>
                    :
                    <></>} */}
                {/* </div> */}
                </Box>
            </Grid>
            <div className="searchformcontainer">
            {(eventsData != null && eventsData.length > 0)
            ?  
                <Grid container spacing={3} className="mt-30px mb-30px p-20px">
                    {
                    sortedEvents.map((events,i) => {
                        return (getEntityData(events,i))
                    })}
                </Grid>
            : 
                <></>
            }
            </div>
        </section>
    )
}
export default SeeIndividualRecord;


